type TabType = "home" | "messages" | "profile";

interface TabNavigationProps {
  activeTab: TabType;
  onTabChange: (tab: TabType) => void;
}

const TabNavigation = ({ activeTab, onTabChange }: TabNavigationProps) => {
  const tabs = [
    { id: "home", label: "🏠 ホーム" },
    { id: "messages", label: "💬 メッセージ" },
    { id: "profile", label: "👤 プロフィール" },
  ] as const;

  return (
    <div className="flex bg-white rounded-lg shadow-sm mb-6 overflow-hidden">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => onTabChange(tab.id as TabType)}
          className={`flex-1 py-3 px-4 text-center font-medium transition-all ${
            activeTab === tab.id
              ? "tab-active"
              : "text-gray-600 hover:bg-gray-50"
          }`}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};

export default TabNavigation;
